import {
  ADD_QUESTION,
  ADD_DESCRIPTION,
  ADD_DATE,
  ADD_TAGS,
  ADD_CATEGORY_QUESTION,
  IS_ANSWER,
  ADD_CATEGORY_QUESTION_STATUS,
  GET_CATEGORY_FROM_API_QUESTION,
  IS_FETCH_CATEGORY_FROM_API,
  ADD_QUESTION_COVER_IMAGE,
  REMOVE_QUESTION_COVER_IMAGE,
  GET_SINGLE_QUESTION_DATA,
  EDIT_QUESTION,
  EDIT_DESCRIPTION_QUESTION,
  EDIT_IS_ANSWER,
  EDIT_TAGS_QUESTION,
  REMOVE_HEAD_IMAGE_QUESTION,
  EDIT_HEAD_IMAGE_QUESTION,
  FETCH_CATEGORY_FROM_API_EDIT_QUESTION,
  EDIT_CATEGORY_QUESTION_STATUS,
  IS_FETCHED_QUESTION,
  RESET_QUESTION_CONTENT
} from "../constants";

const initialQuestionData = {
  question: "",
  description: "",
  datePublished: "",
  category: [],
  categoryStore: [],
  tags: [],
  isAnswer: true,
  active: "",
  questionFile: "",
  headImage: "",
  isFetchCat: false,

  editQuestion: "",
  editDescription: "",
  editHeadImage: "",
  editTags: [],
  editIsAnswer: true,
  editContent: "",
  editQuestionFile: "",
  isSingleDataFetch: false,
  editCategory: [],
  editCategoryStore: [],
  isFetchedQuestion: false,
  questionPostID: "",
  isEditCategoryFetch: false,
};

const questionData = (state = initialQuestionData, action) => {
  switch (action.type) {
    case ADD_QUESTION: {
      state.question = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DESCRIPTION: {
      state.description = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DATE: {
      state.datePublished = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_TAGS: {
      state.tags = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_CATEGORY_QUESTION: {
      var newCat = [...state.category]
      newCat.push({
        value: action.payload.value,
        status: true
      })
      return {
        ...state,
        category: newCat
      };
    }
    case IS_ANSWER: {
      state.isAnswer = !state.isAnswer;
      return {
        ...state,
      };
    }
    case ADD_CATEGORY_QUESTION_STATUS: {
      var catList = [...state.category];
      var catStore = [...state.categoryStore];
      var indexOf = catStore.findIndex(x => x.value === action.payload.value.value)
      if (action.payload.bool === true) {
        if (catList.length >= 3) {
          alert("reached Maximum");
        } else {
          catList.push(action.payload.value.value);
          catStore[indexOf].status = true;
        }
      }
      if (action.payload.bool === false) {
        catList.map((catItem) => {
          if (action.payload.value.value === catItem) {
            var indexToRemove = catList.indexOf(catItem)
            return catList.splice(indexToRemove,1)
          }
        })
        catStore.map((listOfCate) => {
          if (action.payload.value.value === listOfCate.value) {
            return listOfCate.status = false
          }
        })
      }
      return {
        ...state,
        category: catList,
      };
    }
    case GET_CATEGORY_FROM_API_QUESTION: {
      return {
        ...state,
        categoryStore: action.payload?.map((list) => {
          return {
            value: list,
            status: false,
          };
        }),
      };
    }
    case ADD_QUESTION_COVER_IMAGE: {
      var file = action.payload.target.files[0];
      {file ? state.headImage = URL.createObjectURL(file) : state.headImage= ''}
      {file ? state.questionFile = file : state.questionFile = ''}
      return {
        ...state,
      };
    }
    case REMOVE_QUESTION_COVER_IMAGE: {
      return {
        ...state,
        questionFile: '',
        headImage: "",
      };
    }
    case IS_FETCH_CATEGORY_FROM_API: {
      return {
        ...state,
        isFetchCat: true
      };
    }
    case GET_SINGLE_QUESTION_DATA: {
      var postData = action.payload;
      var editCategoryList = postData.category.map((list) => {
        return {
          value: list,
          status: true,
        };
      });
      return {
        ...state,
        questionPostID: postData.id,
        editQuestion: postData.title,
        editDescription: postData.description,
        editHeadImage:
          postData.banner_image === null ? "" : postData.banner_image,
        editTags: [...action.payload.tags],
        editIsAnswer: postData.answer_status === "1" ? true : false,
        editContent: postData.content,
        editQuestionFile: "",
        editCategory: postData.category,
        editCategoryStore: editCategoryList,
      };
    }
    case EDIT_QUESTION: {
      return {
        ...state,
        editQuestion: action.payload,
      };
    }
    case EDIT_DESCRIPTION_QUESTION: {
      return {
        ...state,
        editDescription: action.payload,
      };
    }
    case EDIT_IS_ANSWER: {
      return {
        ...state,
        editIsAnswer: !state.editIsAnswer,
      };
    }
    case EDIT_TAGS_QUESTION: {
      return {
        ...state,
        editTags: [...action.payload],
      };
    }
    case REMOVE_HEAD_IMAGE_QUESTION: {
      return {
        ...state,
        editQuestionFile: "",
        editHeadImage: "",
      };
    }
    case EDIT_HEAD_IMAGE_QUESTION: {
      var file = action.payload.target.files[0];
      file ? (state.editHeadImage = URL.createObjectURL(file)) : (state.editHeadImage = "");
      file ? (state.editQuestionFile = file) : (state.editBlogFile = "");
      return {
        ...state,
      };
    }
    case FETCH_CATEGORY_FROM_API_EDIT_QUESTION: {
      // var prevEditCategoryStore = [...state.editCategoryStore];
      // var editCategoryList = action.payload.map((list) => {
      //   return {
      //     value: list,
      //     status: prevEditCategoryStore[0]?.value === list ? true : false,
      //   };
      // }); 
      // return {
      //   ...state,
      //   editCategoryStore: [...editCategoryList],
      // };
      if(state.isEditCategoryFetch === false){
        state.isEditCategoryFetch = true
        var prevEditCategoryStore = [...state.editCategoryStore];
        var editCategoryList = action.payload.map((list) => {
          return {
            value: list,
            status: false,
          };
        });
        var arrFin = []
        editCategoryList.map((items) => {
          for (let i = 0; i < prevEditCategoryStore.length; i++) {
            if (items.value === prevEditCategoryStore[i].value) {
              arrFin.push({ value: items.value, status: true })
              return arrFin;
            }
          }
          arrFin.push(items)
          return arrFin;
        })
        return {
          ...state,
          editCategoryStore: [...arrFin],
        };
      }else{
        return {...state}
      }
    }
    case EDIT_CATEGORY_QUESTION_STATUS: {
      var catList = [...state.editCategory];
      var catStore = [...state.editCategoryStore];
      var indexOf = catStore.findIndex(x => x.value === action.payload.value.value)
      if (action.payload.bool === true) {
        if (catList.length >= 3) {
          alert("Maximum Reached");
        } else {
          catList.push(action.payload.value.value);
          catStore[indexOf].status = true;
        }
      }
      if (action.payload.bool === false) {
        catList.map((catItem) => {
          if (action.payload.value.value === catItem) {
            var indexToRemove = catList.indexOf(catItem);
            return catList.splice(indexToRemove, 1);
          }
        });
        catStore.map((listOfCate) => {
          if (action.payload.value.value === listOfCate.value) {
            return (listOfCate.status = false);
          }
        });
      }
      return {
        ...state,
        editCategory: catList,
      };
    }
    case IS_FETCHED_QUESTION: {
      state.isFetchedQuestion = action.payload
      return {
        ...state,
      };
    }
    case RESET_QUESTION_CONTENT: {
      state.question = ""
      state.description = ""
      state.category = []
      state.tags = []
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
export default questionData;

